import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import "./InputAgendaItem.module.scss";

/**
 * Import components
 */
import Button from "components/UI/Button/Button";
import Select from "react-select";
import Checkbox from "components/UI/Checkbox/Checkbox";
import Tip from "components/UI/Tip/Tip";
import Modal from "react-responsive-modal";
import MoveSubject from "components/UI/Popup/MoveSubject/MoveSubject";
/**
 * Import FontAwesome
 */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * Import actions
 */
import storeEvent from "actions/event/store";
import updateEvent from "actions/event/update";

const mapStateToProps = (state, props) => {
    return {
        date: state.new_homework.date
    };
};

const mapDispatchToProps = {
    storeEvent,
    updateEvent
};

const customStyles = {
    control: styles => ({
        ...styles,
        fontSize: "12px"
    }),
    option: styles => ({
        ...styles,
        fontSize: "12px"
    }),
    container: styles => ({
        ...styles,
        width: "100%",
        minHeight: "48px"
    }),
    dropdownIndicator: styles => ({
        ...styles,
        padding: "0px 2px 0 0"
    }),
    valueContainer: styles => ({
        ...styles,
        padding: "2px 6px"
    })
};

const recurrenceTypes = [
    {
        value: "",
        label: "Geen"
    },
    {
        value: "weekly",
        label: "Elke week"
    },
    {
        value: "monthly",
        label: "Maandelijks"
    },
    {
        value: "yearly",
        label: "Jaarlijks"
    }
];

const valueFromId = (opts, id) => opts.find(o => o.value === id);
const valueFromLabel = (opts, label) => opts.find(o => o.label === label);
const valueFromValue = (opts, value) => opts.find(o => o.value === value);

const timesMins = [
    {
        value: 0,
        label: "00"
    },
    {
        value: 1,
        label: "05"
    },
    {
        value: 2,
        label: "10"
    },
    {
        value: 3,
        label: "15"
    },
    {
        value: 4,
        label: "20"
    },
    {
        value: 5,
        label: "25"
    },
    {
        value: 6,
        label: "30"
    },
    {
        value: 7,
        label: "35"
    },
    {
        value: 8,
        label: "40"
    },
    {
        value: 9,
        label: "45"
    },
    {
        value: 10,
        label: "50"
    },
    {
        value: 11,
        label: "55"
    }
];

const times = [
    {
        value: 0,
        label: "00"
    },
    {
        value: 1,
        label: "01"
    },
    {
        value: 2,
        label: "02"
    },
    {
        value: 3,
        label: "03"
    },
    {
        value: 4,
        label: "04"
    },
    {
        value: 5,
        label: "05"
    },
    {
        value: 6,
        label: "06"
    },
    {
        value: 7,
        label: "07"
    },
    {
        value: 8,
        label: "08"
    },
    {
        value: 9,
        label: "09"
    },
    {
        value: 10,
        label: "10"
    },
    {
        value: 11,
        label: "11"
    },
    {
        value: 12,
        label: "12"
    },
    {
        value: 13,
        label: "13"
    },
    {
        value: 14,
        label: "14"
    },
    {
        value: 15,
        label: "15"
    },
    {
        value: 16,
        label: "16"
    },
    {
        value: 17,
        label: "17"
    },
    {
        value: 18,
        label: "18"
    },
    {
        value: 19,
        label: "19"
    },
    {
        value: 20,
        label: "20"
    },
    {
        value: 21,
        label: "21"
    },
    {
        value: 22,
        label: "22"
    },
    {
        value: 23,
        label: "23"
    }
];

const months = [
    {
        label: "Januari",
        value: 1
    },
    {
        label: "Februari",
        value: 2
    },
    {
        label: "Maart",
        value: 3
    },
    {
        label: "April",
        value: 4
    },
    {
        label: "Mei",
        value: 5
    },
    {
        label: "Juni",
        value: 6
    },
    {
        label: "Juli",
        value: 7
    },
    {
        label: "Augustus",
        value: 8
    },
    {
        label: "September",
        value: 9
    },
    {
        label: "Oktober",
        value: 10
    },
    {
        label: "November",
        value: 11
    },
    {
        label: "December",
        value: 12
    }
];

const years = [
    {
        label: "2020",
        value: 2020
    },
    {
        label: "2021",
        value: 2021
    },
    {
        label: "2022",
        value: 2022
    },
    {
        label: "2023",
        value: 2023
    },
    {
        label: "2024",
        value: 2024
    },
    {
        label: "2025",
        value: 2025
    },
    {
        label: "2026",
        value: 2026
    }
];
const customStyles1 = {
    container: styles => ({
        ...styles,
        width: "79px",
        marginRight: "8px"
    }),
    control: styles => ({
        ...styles,
        fontSize: "12px"
        //height: "49px"
    }),
    option: styles => ({
        ...styles,
        fontSize: "12px"
    })
};
const customStyles2 = {
    container: styles => ({
        ...styles,
        width: "97px",
        marginRight: "8px"
    }),
    control: styles => ({
        ...styles,
        fontSize: "12px"
        //height: "49px"
    }),
    option: styles => ({
        ...styles,
        fontSize: "12px"
    })
};
const customDayStyle = {
    container: styles => ({
        ...styles,
        width: "63px",
        marginRight: "8px"
    }),
    control: styles => ({
        ...styles,
        fontSize: "12px"
        //height: "49px"
    }),
    option: styles => ({
        ...styles,
        fontSize: "12px"
    })
};

class InputAgendaItem extends Component {
    constructor() {
        super();

        let today = new Date();

        this.state = {
            recurrenceOption: "",
            user_subject_id: 23,
            timeslot: 99,
            duration: 1,
            description: "",
            note: "",
            start_at: "09:00",
            end_at: "10:00",
            image: null,
            day: today.getDate(),
            month: today.getMonth() + 1,
            year: today.getFullYear()
        };

        this.handleClose = this.handleClose.bind(this);
        this.deleteImage = this.deleteImage.bind(this);
        this.onImageChange = this.onImageChange.bind(this);
        this.toggleTip = this.toggleTip.bind(this);
        this.openImage = this.openImage.bind(this);
        this.handleRecurranceChange = this.handleRecurranceChange.bind(this);
        this.handleText = this.handleText.bind(this);
        this.handleStartChange = this.handleStartChange.bind(this);
        this.handleEndChange = this.handleEndChange.bind(this);
        this.storeAppointment = this.storeAppointment.bind(this);
        this.updateEventWithChosenEditMode = this.updateEventWithChosenEditMode.bind(
            this
        );
        this.updateEvent = this.updateEvent.bind(this);
    }

    componentDidMount() {
        if (this.props.date) {
            let array = this.props.date.split("-");
            this.setState({
                day: parseInt(array[2]),
                month: parseInt(array[1]),
                year: parseInt(array[0])
            });
        }
        if (this.props.editItem) {
            let recurrence = "";
            let event = this.props.editItem;

            if (event.isRecurring == false) {
                recurrence = "";
            } else if (
                event.isRecurring &&
                event.recurrencePattern.includes("WEEKLY") &&
                event.recurrencePattern.includes("INTERVAL=1")
            ) {
                recurrence = "weekly";
            } else if (
                event.isRecurring &&
                event.recurrencePattern.includes("WEEKLY") &&
                event.recurrencePattern.includes("INTERVAL=2")
            ) {
                recurrence = "biweekly";
            } else if (
                event.isRecurring &&
                event.recurrencePattern.includes("WEEKLY") &&
                event.recurrencePattern.includes("INTERVAL=4")
            ) {
                recurrence = "monthly";
            }

            this.setState({
                editing: true,
                start_at: this.props.editItem.start_at,
                end_at: this.props.editItem.end_at,
                description: this.props.editItem.description,
                note: this.props.editItem.note,
                image: this.props.editItem.image,
                recurrenceOption: recurrence,
                oldRecurrence: recurrence,
                user_subject_id: this.props.editItem.user_subject_id
            });
        }
    }

    onImageChange(e) {
        const files = Array.from(e.target.files);
        if (files.length < 1) {
            return;
        }

        const image = files[0];
        let reader = new FileReader();

        reader.onloadend = () => {
            this.setState({
                imagePreviewUrl: reader.result
            });
            this.setState({ image: image });
        };

        reader.readAsDataURL(image);
    }

    dayValues() {
        const dayValues = [];

        for (let i = 1; i <= 31; i++) {
            let tempObject = {
                value: i,
                label: `${i}`
            };
            dayValues.push(tempObject);
        }
        return dayValues;
    }

    deleteImage() {
        this.setState({
            imagePreviewUrl: null
        });
        this.setState({ image: null });
    }

    handleClose(event) {
        this.props.handleClose(event);
        this.props.homeworkReset();
    }

    toggleTip() {
        this.setState({ showTip: !this.state.showTip });
    }

    openImage(data) {
        var image = new Image();
        image.src = data;
        var w = window.open("");
        w.document.write(image.outerHTML);
    }

    handleRecurranceChange(value) {
        this.setState({
            recurrenceOption: value.value
        });
    }

    handleText(event) {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    handleStartChange(value, timeUnit) {
        if (timeUnit == "hour") {
            if (!this.state.start_at) {
                this.setState({
                    start_at: `${value.label}:00`,
                    end_at: `${
                        times[value.value + 1]
                            ? times[value.value + 1].label
                            : "00"
                    }:00`
                    //end_at: times[value.value + 2] ? times[value.value + 2].label : '00:00'
                });
            } else {
                this.setState({
                    start_at: `${value.label}:${this.state.start_at.slice(
                        3,
                        5
                    )}`,
                    end_at: `${
                        times[value.value + 1]
                            ? times[value.value + 1].label
                            : "00"
                    }:${this.state.start_at.slice(3, 5)}`
                    //end_at: times[value.value + 2] ? times[value.value + 2].label : '00:00'
                });
            }
        }
        if (timeUnit == "min") {
            let hour = this.state.start_at.slice(0, 2);
            let hourend = this.state.end_at.slice(0, 2);
            this.setState({
                start_at: `${hour}:${value.label}`,
                end_at: `${hourend}:${value.label}`
                // end_at: times[value.value + 2] ? times[value.value + 2].label : '00:00'
            });
        }
        console.log("start time");
        console.log(this.state.start_at.slice(0, 2));
        console.log(":");
        console.log(this.state.start_at.slice(3, 5));
        console.log(this.state.start_at);
        console.log(this.state.end_at);
        console.log("____________________________");
    }

    handleEndChange(value, timeUnit) {
        if (timeUnit == "hour") {
            this.setState({
                end_at: `${value.label}:${this.state.end_at.slice(3, 5)}`
            });
        }
        if (timeUnit == "min") {
            this.setState({
                end_at: `${this.state.end_at.slice(0, 2)}:${value.label}`
            });
        }
        console.log("end time");
        console.log(this.state.end_at.slice(0, 2));
        console.log(":");
        console.log(this.state.end_at.slice(3, 5));
        console.log(this.state.end_at);
        console.log("____________________________");
    }

    storeAppointment() {
        let appointment = {
            recurrence: this.state.recurrenceOption,
            start_date: `${this.state.year}-${this.state.month}-${this.state.day}`,
            timeslot: 99,
            duration: 1,
            description: this.state.description,
            note: this.state.note,
            start_at: this.state.start_at,
            end_at: this.state.end_at,
            image: this.state.image
        };

        this.props.storeEvent(appointment);

        this.setState({
            recurrenceOption: "",
            user_subject_id: 23,
            timeslot: 99,
            duration: 1,
            description: "",
            note: "",
            start_at: "",
            end_at: ""
        });

        this.props.handleClose();
    }

    updateEventWithChosenEditMode(editMode) {
        let event = {
            ...this.props.editItem,
            ...this.state,
            recurrence: this.state.recurrenceOption
        };

        this.props
            .updateEvent({
                id: event.id,
                redit: editMode,
                origid: event.origid,
                startDateUtc: `${event.year}-${event.month}-${event.day}`,
                endDateUtc: `${event.year}-${event.month}-${event.day}`,
                ristart: event.startDateUtc,
                recurrence: event.recurrence,
                start_at: event.start_at,
                end_at: event.end_at,
                user_subject_id: event.user_subject_id,
                note: event.note,
                description: event.description,
                recurrencePattern: event.recurrencePattern,
                isRecurring: 1,
                timeslot: 99
            })
            .then(result => {
                this.props.handleClose();
            });
    }

    updateEvent() {
        let event = {
            ...this.props.editItem,
            ...this.state,
            recurrence: this.state.recurrenceOption
        };

        if (
            this.props.editItem.isRecurring &&
            event.recurrence == event.oldRecurrence &&
            (event.start_at != this.props.editItem.start_at ||
                event.end_at != this.props.editItem.end_at ||
                event.description != this.props.editItem.description ||
                event.note != this.props.editItem.note ||
                `${event.year}-${event.month}-${event.day}` !=
                    this.props.editItem.startDateUtc)
        ) {
            this.setState({
                showSubjectMovedPopup: true
            });
            return;
        }

        if (!this.props.editItem.isRecurring) {
            //the old event was non-recurring, so just update the event
            this.props
                .updateEvent({
                    id: event.id,
                    startDateUtc: `${event.year}-${event.month}-${event.day}`,
                    endDateUtc: `${event.year}-${event.month}-${event.day}`,
                    recurrence: event.recurrence,
                    start_at: event.start_at,
                    end_at: event.end_at,
                    note: event.note,
                    description: event.description,
                    recurrencePattern:
                        event.recurrence != "" ? event.recurrence : null
                })
                .then(result => {
                    this.props.handleClose();
                });
        } else {
            //old event was recurring, change it
            let recurrencePattern = null;

            switch (event.recurrence) {
                case "":
                    break;
                case "weekly":
                    recurrencePattern = "FREQ=WEEKLY;INTERVAL=1";
                    break;
                case "monthly":
                    recurrencePattern = "FREQ=MONTHLY;INTERVAL=1";
                    break;
                case "yearly":
                    recurrencePattern = "FREQ=YEARLY;INTERVAL=1";
                    break;
            }

            this.props
                .updateEvent({
                    id: event.id,
                    redit: "future",
                    origid: event.origid,
                    startDateUtc: event.startDateUtc,
                    ristart: event.startDateUtc,
                    start_at: event.start_at,
                    end_at: event.end_at,
                    note: event.note,
                    description: event.description,
                    recurrence: event.recurrenceOption,
                    timeslot: 99,
                    user_subject_id: event.user_subject_id,
                    recurrencePattern: recurrencePattern,
                    isRecurring: recurrencePattern != null
                })
                .then(result => {
                    this.setState({
                        recurrenceOption: "",
                        user_subject_id: 23,
                        timeslot: 99,
                        duration: 1,
                        description: "",
                        note: "",
                        start_at: "",
                        end_at: "",
                        editing: false
                    });

                    this.props.onClose();
                });
        }
    }

    render() {
        let screenWidth = window.innerWidth;
        return (
            <Fragment>
                <div styleName="input-content">
                    <div styleName="top-bar">
                        <h1 styleName="title">
                            Agenda item{" "}
                            {this.state.editing ? "bewerken" : "invoeren"}
                        </h1>
                    </div>
                    <div styleName="card-content">
                        <Fragment>
                            <div styleName="date-wrapper">
                                <Select
                                    onChange={e => {
                                        this.setState({ day: e.value });
                                    }}
                                    value={valueFromValue(
                                        this.dayValues(),
                                        this.state.day
                                    )}
                                    options={this.dayValues()}
                                    styles={customDayStyle}
                                    placeholder={"Dag"}
                                    isSearchable={false}
                                    components={{
                                        IndicatorSeparator: () => null
                                    }}
                                />
                                <Select
                                    onChange={e => {
                                        this.setState({ month: e.value });
                                    }}
                                    value={valueFromValue(
                                        months,
                                        this.state.month
                                    )}
                                    options={months}
                                    styles={customStyles2}
                                    placeholder={"Maand"}
                                    isSearchable={false}
                                    components={{
                                        IndicatorSeparator: () => null
                                    }}
                                />
                                <Select
                                    onChange={e => {
                                        this.setState({ year: e.value });
                                    }}
                                    value={valueFromValue(
                                        years,
                                        this.state.year
                                    )}
                                    options={years}
                                    styles={customStyles1}
                                    placeholder={"Jaar"}
                                    isSearchable={false}
                                    components={{
                                        IndicatorSeparator: () => null
                                    }}
                                />
                            </div>
                            <div styleName="dropdown-wrapper">
                                <div styleName="dropdown">
                                    <p>Van</p>
                                    <div styleName="select-wrapper">
                                        <Select
                                            onChange={value => {
                                                this.handleStartChange(
                                                    value,
                                                    "hour"
                                                );
                                            }}
                                            value={valueFromLabel(
                                                times,
                                                this.state.start_at.slice(0, 2)
                                            )}
                                            options={times}
                                            styles={customStyles}
                                            isSearchable={screenWidth > 1024}
                                            placeholder={"uur"}
                                            components={{
                                                IndicatorSeparator: () => null
                                            }}
                                        />
                                        <Select
                                            onChange={value => {
                                                this.handleStartChange(
                                                    value,
                                                    "min"
                                                );
                                            }}
                                            value={valueFromLabel(
                                                times,
                                                this.state.start_at.slice(3, 5)
                                            )}
                                            options={timesMins}
                                            styles={customStyles}
                                            isSearchable={screenWidth > 1024}
                                            placeholder={"min"}
                                            components={{
                                                IndicatorSeparator: () => null
                                            }}
                                        />
                                    </div>
                                </div>
                                <div styleName="dropdown">
                                    <p>Tot</p>
                                    <div styleName="select-wrapper">
                                        <Select
                                            onChange={value => {
                                                this.handleEndChange(
                                                    value,
                                                    "hour"
                                                );
                                            }}
                                            value={valueFromLabel(
                                                times,
                                                this.state.end_at.slice(0, 2)
                                            )}
                                            options={times}
                                            styles={customStyles}
                                            isSearchable={screenWidth > 1024}
                                            placeholder={"uur"}
                                            components={{
                                                IndicatorSeparator: () => null
                                            }}
                                        />
                                        <Select
                                            onChange={value => {
                                                this.handleEndChange(
                                                    value,
                                                    "min"
                                                );
                                            }}
                                            value={valueFromLabel(
                                                timesMins,
                                                this.state.end_at.slice(3, 5)
                                            )}
                                            options={timesMins}
                                            styles={customStyles}
                                            isSearchable={screenWidth > 1024}
                                            placeholder={"min"}
                                            components={{
                                                IndicatorSeparator: () => null
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div styleName="tip-wrapper">
                                <p>Beschrijving (max 50 tekens)*</p>
                                <Tip
                                    tip="Verzin afkortingen voor het huiswerk. Om het overzicht te bewaren en om ruimte te besparen en om snel je huiswerk in te kunnen voeren. Voorbeeld: ipv paragraaf schrijf je par. SO voor schriftelijke overhoring of H voor hoofdstuk, enz"
                                    image="/images/tips/1.png"
                                />
                            </div>
                            <input
                                styleName="input-description"
                                type="text"
                                name="description"
                                value={this.state.description}
                                onChange={this.handleText}
                                maxLength="50"
                                placeholder="Bijvoorbeeld par 1,2,3"
                            />
                            <p>Notitie</p>
                            <div styleName="note-background">
                                <textarea
                                    styleName="note"
                                    type="text"
                                    placeholder="Notitie"
                                    name="note"
                                    value={this.state.note}
                                    onChange={this.handleText}
                                />
                                <label styleName="icon" htmlFor="single">
                                    <FontAwesomeIcon
                                        style={{
                                            margin: "10px 10px 0 0",
                                            cursor: "pointer",
                                            fontSize: "14px"
                                        }}
                                        icon={["fas", "camera"]}
                                    />
                                </label>
                                <input
                                    styleName="hidden-input"
                                    type="file"
                                    id="single"
                                    onChange={this.onImageChange}
                                />
                            </div>
                            {this.state.imagePreviewUrl && (
                                <div styleName="image">
                                    <FontAwesomeIcon
                                        onClick={this.deleteImage}
                                        styleName="delete"
                                        icon={["far", "times"]}
                                    />
                                    <Button
                                        title="Bijlage bekijken"
                                        normal
                                        style={{
                                            background:
                                                "rgba(0, 136, 254, 0.15)",
                                            color: "#0088fe",
                                            borderRadius: "3px",
                                            height: "36px",
                                            width: "214px"
                                        }}
                                        icon={["fal", "paperclip"]}
                                        smallIcon
                                        handleClick={() =>
                                            this.openImage(
                                                this.state.imagePreviewUrl
                                            )
                                        }
                                    />
                                </div>
                            )}
                            <p>Herhaling</p>
                            <Select
                                onChange={this.handleRecurranceChange}
                                value={valueFromValue(
                                    recurrenceTypes,
                                    this.state.recurrenceOption
                                )}
                                options={recurrenceTypes}
                                isSearchable={false}
                                styles={customStyles}
                                components={{
                                    IndicatorSeparator: () => null
                                }}
                            />
                            <div styleName="buttons">
                                <p onClick={this.handleClose}>Annuleer</p>
                                <p
                                    styleName="save"
                                    onClick={
                                        this.state.editing
                                            ? this.updateEvent
                                            : this.storeAppointment
                                    }
                                >
                                    {this.state.editing
                                        ? "Bijwerken"
                                        : "Opslaan"}
                                </p>
                            </div>
                        </Fragment>
                    </div>
                </div>
                <Modal
                    open={this.state.showSubjectMovedPopup}
                    onClose={this.closeSubjectMovedPopup}
                    center
                    styles={{
                        modal: {
                            borderRadius: "6px",
                            width: "500px",
                            height: "110px",
                            padding: "10px 15px"
                        },
                        closeIcon: {
                            display: "none"
                        }
                    }}
                >
                    <MoveSubject
                        changeInsteadOfMove
                        agendaInsteadOfSubject
                        moveSubject={this.updateEventWithChosenEditMode}
                        onClose={this.closeSubjectMovedPopup}
                    />
                </Modal>
            </Fragment>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InputAgendaItem);
